import axiosInstance from '@/store/axios'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    upload ({ commit }, data) {
      const headers = {
        'Content-Type': 'multipart/form-data',
      }
      const params = {}
      if (data.instanceId) {
        params.instance_id = data.instanceId
      }
      return axiosInstance.post('/api/v1/upload', data.file, {
        params,
        headers,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
  },
}
